/*
 * JUNGCARDS sale teaser (snippets/jc-sale-popup.liquid).
 *
 * Plays second fiddle to the spin wheel (assets/jc-spin.js): if the wheel may auto-open on this
 * page view (same rules as jc-spin.js: auto on, home/collection/search/blog, not spun, not closed
 * in the last 7 days), the teaser stays away for this page view. It also never shows while any
 * dialog, drawer or the cookie banner is open, waits ~12 s and for the visitor to scroll a little,
 * shows at most once per session, then pauses 3 days after closing or 14 days after a click.
 * Phones: not on product pages (the sticky add-to-cart bar owns the bottom there).
 */
(function () {
  var box = document.querySelector('[data-jc-sale]');
  if (!box) return;

  var STORE = 'jc_sale_v1';
  var SESSION = 'jc_sale_seen';
  var CLOSE_DAYS = 3;
  var CLICK_DAYS = 14;
  var DELAY = 12000;
  var SCROLL_PX = 250;
  var SPIN_STORE = 'jc_spin_v1';
  var SPIN_DISMISS_DAYS = 7;
  var SPIN_TEMPLATES = /^(index|collection|list-collections|search|blog|article)(\.|$)/;

  function read(store, key) {
    try {
      return JSON.parse(store.getItem(key)) || {};
    } catch (e) {
      return {};
    }
  }

  function write(value) {
    try {
      localStorage.setItem(STORE, JSON.stringify(value));
    } catch (e) {}
  }

  var saved = read(localStorage, STORE);
  var now = Date.now();
  if (saved.clicked && now - saved.clicked < CLICK_DAYS * 864e5) return;
  if (saved.closed && now - saved.closed < CLOSE_DAYS * 864e5) return;
  try {
    if (sessionStorage.getItem(SESSION)) return;
  } catch (e) {}

  var phone = window.matchMedia('(max-width: 749px)').matches;
  if (phone && /^product(\.|$)/.test(box.dataset.template)) return;

  /* The wheel goes first: same conditions as its auto-open in jc-spin.js. */
  function wheelMayOpen() {
    var wheel = document.querySelector('[data-jc-spin]');
    if (!wheel || wheel.dataset.auto !== 'true' || !SPIN_TEMPLATES.test(wheel.dataset.template || '')) return false;
    var spin = read(localStorage, SPIN_STORE);
    if (spin.code || spin.pending) return false;
    return !(spin.dismissed && now - spin.dismissed < SPIN_DISMISS_DAYS * 864e5);
  }
  if (wheelMayOpen()) return;

  function busy() {
    var banner = document.getElementById('shopify-pc__banner');
    return (
      document.hidden ||
      document.documentElement.classList.contains('jc-spin-open') ||
      (banner && banner.offsetParent !== null && getComputedStyle(banner).display !== 'none') ||
      document.querySelector('dialog[open], details[open] > .menu-drawer, .drawer.active, cart-drawer.active') ||
      document.body.classList.contains('overflow-hidden') ||
      document.body.classList.contains('overflow-hidden-tablet') ||
      document.body.classList.contains('overflow-hidden-mobile')
    );
  }

  var scrolled = false;
  function onScroll() {
    if (window.scrollY > SCROLL_PX) {
      scrolled = true;
      window.removeEventListener('scroll', onScroll);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  function show() {
    try {
      sessionStorage.setItem(SESSION, '1');
    } catch (e) {}
    box.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        box.classList.add('is-in');
      });
    });
    document.addEventListener('keydown', onKey);
  }

  function hide(record) {
    write(record);
    document.removeEventListener('keydown', onKey);
    box.classList.remove('is-in');
    setTimeout(function () {
      box.hidden = true;
    }, 380);
  }

  function onKey(event) {
    if (event.key === 'Escape') hide({ closed: Date.now() });
  }

  box.querySelector('[data-jc-sale-close]').addEventListener('click', function () {
    hide({ closed: Date.now() });
  });

  box.querySelector('[data-jc-sale-cta]').addEventListener('click', function () {
    write({ clicked: Date.now() });
  });

  function tryShow() {
    if (!scrolled || busy()) {
      setTimeout(tryShow, 3000);
      return;
    }
    show();
  }
  setTimeout(tryShow, DELAY);
})();
